import { createContext } from "react";

const AreaContext = createContext();

export default AreaContext;
